import { isNumber, isString } from '../fold-helpers';
import { createWidgetNormalizer } from '../create-widget-normalizer';

/**
 * Lifts a flat top-level field into `data` — the same "model sent `{ columnId, textColor }` instead
 * of nesting it" miss indent's normalizer exists for, generalized to every scalar field this widget
 * has. `menuList`/`hoverEffects` are objects/arrays rather than scalars, so they get their own
 * `accepts` check instead of reusing `isString`/`isNumber`.
 */
const navigationNormalizer = createWidgetNormalizer({
    rules: [
        { target: 'textColor', accepts: isString },
        { target: 'submenuTextColor', accepts: isString },
        { target: 'fontSize', accepts: isNumber },
        { target: 'submenuFontSize', accepts: isNumber },
        { target: 'menuItemIndent', accepts: isString },
        { target: 'horizontalPosition', accepts: isString },
        { target: 'submenuListBackground', accepts: isString },
        { target: 'layoutDirection', accepts: isString },
        { target: 'menuList', accepts: Array.isArray },
        { target: 'fontStyle', accepts: Array.isArray },
        { target: 'submenuFontStyle', accepts: Array.isArray },
        { target: 'hoverEffects', accepts: (value: unknown) => typeof value === 'object' && value !== null },
    ],
    optionalData: true,
});

export function normalizeNavigationWidgetArgs(raw: unknown): unknown {
    return navigationNormalizer.normalize(raw);
}
